import { UNEXPECTED_EXCEPTION } from "../../../api/shared";

export type ResponseError = {
  message?: string;
  code?: string;
  response?: {
    status: number;
    data?: {
      errorCode?: string;
      translationKey?: string;
    };
  };
  config?: {
    url: string;
    method: string;
    baseURL?: string;
  };
};

export const getResponseErrorKey = (error: ResponseError) => {
  return error?.response?.data?.translationKey;
};

export const getOnlySpecificErrorKey = (error: ResponseError) => {
  const errorKey = getResponseErrorKey(error);
  return errorKey === UNEXPECTED_EXCEPTION ? undefined : errorKey;
};

export const errorWithCode = (error: ResponseError) => {
  return {
    message: `${getOnlySpecificErrorKey(error)}`,
  };
};
